@use "../../../globals/settings";
@use "../../../globals/bcp";
@use "../../../globals/bcp-2022/objects/buttons";
@use "../../../globals/bcp-2022/objects/links";

$self: ".a-button";

:host {
  // ------------------- FIX CUSTOM TAGS ------------------------------------------------------------------------------
  display: inline-block;
  vertical-align: middle;
}

// ------------------- FROK -----------------------------------------------------------------------------------------
.a-button {
  @include buttons.base;

  &__label {
    @include buttons.text;
  }

  &--fixed {
    width: bcp.size(128);

    #{$self}__label {
      @include bcp.text-overflow();
      display: block;
      width: 100%;
      height: bcp.size(24);
    }
  }

  &--full-width {
    width: 100%;
    justify-content: center;
  }

  &--not-centered {
    width: 100%;
    justify-content: flex-start;
    #{$self}__label {
      margin: 0;
    }
  }

  &--icon-only {
    #{$self}__label {
      padding: bcp.size(11);
    }
  }

  &--primary {
    @include buttons.primary;
  }

  &--secondary {
    @include buttons.secondary;
  }

  &--tertiary {
    @include buttons.tertiary;
  }

  &--integrated {
    @include buttons.integrated;
  }

  &--transparent {
    @include buttons.transparent();

    #{$self}__label {
      padding: 0;
    }
  }

  &--link-simple {
    @include links.simple;
    background-color: transparent;

    #{$self}__label {
      padding: 0;
    }
  }
}

:host(.fullWidth) {
  width: 100%;
}

:host(.disabled) {
  pointer-events: none;
}

// ------------------- CUSTOM -----------------------------------------------------------------------------------------
// ...

.a-button--tt-static-height .a-button__label {
  max-height: bcp.size(24);
}

.a-button--tt-header-search.a-button--primary {
  @include bcp.theme("buderus") {
    @include bcp.set-css-var(c-button-primary, bg, settings.$search-dark-bg);
    @include bcp.set-css-var(
      c-button-primary,
      border,
      settings.$search-dark-bg
    );
    @include bcp.set-css-var(
      c-button-primary,
      hover-bg,
      settings.$search-dark-hover-bg
    );
    @include bcp.set-css-var(
      c-button-primary,
      hover-border,
      settings.$search-dark-hover-bg
    );
    @include bcp.set-css-var(
      c-button-primary,
      active-bg,
      settings.$search-dark-bg
    );
    @include bcp.set-css-var(
      c-button-primary,
      active-border,
      settings.$search-dark-bg
    );
    @include bcp.set-css-var(icon, color, settings.$black);
  }
}
